import "./App.css";
import { Routes } from "react-router-dom";
import Pages from "./pages/Pages";
import { ThemeProvider } from "@emotion/react";
import theme from "./theme";
import { CssBaseline } from "@mui/material";
import useEventId from "./util/useEventId";
import { ApiProvider } from "./api/ApiProvider";

export default function App() {
  useEventId();
  const routes = Pages.GetRoutes();
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ApiProvider>
        <Routes>{routes}</Routes>
      </ApiProvider>
    </ThemeProvider>
  );
}
